import NextErrorComponent from 'next/error';
import * as Sentry from '@sentry/nextjs';
import { CustomError } from 'components/error/Error';
import PropTypes from 'prop-types';
// import Error from 'pages/_error';

const MyError = ({
  statusCode,
  hasGetInitialPropsRun,
  err
}) => {

  if (!hasGetInitialPropsRun && err) {

    Sentry.captureException(err);

  }

  return (
    <CustomError code={statusCode} />
  );

};

MyError.getInitialProps = async (context) => {

  const errorInitialProps = await NextErrorComponent.getInitialProps(context);

  const {
    res,
    err,
    asPath
  } = context;

  errorInitialProps.hasGetInitialPropsRun = true;

  if (res?.statusCode === 404) {

    return errorInitialProps;

  }

  if (err) {
    console.error(err);
    Sentry.captureException(err);

    await Sentry.flush(2000);

    return errorInitialProps;

  }

  Sentry.captureException(
    new Error(`_error.js getInitialProps missing data at path: ${asPath}`),
  );
  await Sentry.flush(2000);

  return errorInitialProps;

};

MyError.propTypes = {
  statusCode: PropTypes.number,
  err: PropTypes.any,
  hasGetInitialPropsRun: PropTypes.any,
};

MyError.defaultProps = {
  statusCode: 500,
  err: undefined,
  hasGetInitialPropsRun: undefined,
};

export default MyError;
